

















import {Component, Vue} from 'vue-property-decorator';
import FAQItem from "@/components/FAQItem.vue";

@Component({
  name: "FAQ",
  components: {
    FAQItem: FAQItem
  }
})
export default class FAQ extends Vue {
  private faqs: any[] = [
    {
      'title': 'Cosa è Job to Job?',
      'text': 'La piattaforma Job to Job è stata lanciata per fornire agli agricoltori e a tutte le altre realtà economiche del territorio un supporto rapido e semplice nel reclutamento di lavoratori.'
    },
    {
      'title': 'Chi si può iscrivere alla piattaforma?',
      'text': 'Per quanto riguarda l\'offerta di opportunità lavorative, si possono iscrivere a Job to Job aziende agricole o di altri settori considerati essenziali bisognose di forza lavoro. Ad esempio, aziende agricole che devono effettuare la raccolta dei prodotti in campo ma trovano difficoltà a causa della mancanza di lavoratori stagionali. Questo è esattamente il punto di partenza del concetto Job to Job.<br><br>Per quanto riguarda la sezione di ricerca di un\'opportunità lavorativa, si può iscrivere chiunque abbia compiuto 16 anni e sia interessato ad un\'opportunità occupazionale stagionale.'
    },
    {
      'title': 'Quanto costa l’utilizzo della piattaforma?',
      'text': 'Job to Job è un servizio gratuito, sia per chi offre lavoro sia per chi lo cerca.'
    },
    {
      'title': 'Posso lavorare nonostante le restrizioni alla mobilità vigenti?',
      'text': 'Il DCPM del 25 di Marzo 2020 considera l\'agricoltura un\'attività essenziale per questo sono permessi spostamenti per scopi lavorativi anche in caso di Zona Rossa.'
    },
    {
      'title': 'Quali dati sono resi pubblici?',
      'text': 'Pubblichiamo il tuo nome, il codice postale e la città in modo che tu possa essere trovato nella tua regione. Puoi decidere se pubblicare il tuo numero di telefono e/o indirizzo e-mail per ricevere le offerte.'
    },
    {
      'title': 'Come vengono protetti i miei dati?',
      'text': 'La piattaforma Job to Job è un sito web aperto a chiunque. Gli annunci pubblicati, il loro contenuto e i dati personali possono essere visualizzati da tutti ai fini di una ricerca efficiente o. I tuoi dati si trovano su un server europeo e vengono utilizzati solo allo scopo di fornire il supporto secondo i nostri termini e condizioni.'
    },
    {
      'title': 'Come funziona la piattaforma Job to Job?',
      'text': 'Job to Job crea una spazio virtuale dove aziende in cerca di manodopera e privati cittadini in cerca di un’occupazione possono entrare in contatto direttamente. Job to Job non garantisce un lavoro, ma vuole facilitare l\'incontro tra offerta e domanda di lavoro. La piattaforma Job to Job funziona in pratica come una "bacheca": puoi registrarti e cercare direttamente, in modo proattivo e senza mediazioni.'
    },
    {
      'title': 'Quale tipologia di lavori vengono offerti nella piattaforma Job to Job?',
      'text': 'Al momento di un processo di assunzione, si entra in un rapporto di lavoro con l’azienda con la quale si chiariscono le condizioni contrattuali.<br><br>Job to Job si schiera apertamente contro ogni tipologia di sfruttamento lavorativo e di caporalato.'
    },
    {
      'title': 'La mia candidatura è vincolante?',
      'text': 'Poiché gli annunci nascono da esigenze urgenti di manodopera per settori economici essenziali come l\'agricoltura, ti chiediamo di pubblicare solo offerte serie.'
    },
  ]

}

